import { createEndpointMaker } from "../sg-core";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
if (!baseUrl) { throw new Error("REACT_APP_API_BASE_URL must be defined") }

const makeEndpoint = createEndpointMaker(baseUrl);

export const Auth = makeEndpoint(["login_v03.aspx"]);

export const havainnot = makeEndpoint(["havainnot_v09.aspx"]);

export const Kohteet = makeEndpoint(["kohteet_v02.aspx"]);

export const Yleiset = makeEndpoint(["yleiset_v04.aspx"]);

export const Upload6 = makeEndpoint(["upload6_v02.aspx"]);

export const Kartta = makeEndpoint(["Kartta_v01.aspx"]);

export const HPR = makeEndpoint(["hpr_v02.aspx"]);
